"use client";

import { useMemo } from "react";

import { createTranslator } from "@/lib/i18n/dictionary";
import { useLanguage } from "@/providers/LanguageProvider";

/**
 * `t()` for client components, bound to the language the server rendered in.
 *
 * The signature is unchanged from the react-i18next version — fully-qualified
 * dotted keys, `{{name}}` interpolation, `returnObjects` — so no call site had
 * to move. What changed is underneath: there is no i18next instance and no
 * global "current language", just a dotted lookup into the registered bundles
 * for `language`. See lib/i18n/dictionary.ts.
 *
 * Server Components should not use this. They build a translator directly with
 * `createTranslator(locale)`, which needs no context and no client boundary.
 */
export function useTranslation() {
  const { language } = useLanguage();
  const t = useMemo(() => createTranslator(language), [language]);

  return { t, language };
}
